export enum RoleStatus {
  Administrator = "Administrator",
  EndUser = "End User",
  CorporateLegal = "Corporate Legal",
  LegalRelation = "Legal Relation",
  BusinessAndActivity = "Business & Activity"
}

export namespace RoleStatus {
  export function toId(status: RoleStatus): string {
    switch (status) {
      case RoleStatus.Administrator:
        return "RL230000001";
      case RoleStatus.EndUser:
        return "RL230000002";
      case RoleStatus.CorporateLegal:
        return "RL230000003";
      case RoleStatus.LegalRelation:
        return "RL230000004";
      case RoleStatus.BusinessAndActivity:
        return "RL240000001";
      default:
        return "";
    }
  }
}
